import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { invalid } from 'moment';
import { NgWizardService } from 'ng-wizard';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';

@Component({
  selector: 'app-com-matrix-config',
  templateUrl: './com-matrix-config.component.html',
  styleUrls: ['./com-matrix-config.component.scss']
})
export class ComMatrixConfigComponent implements OnInit {
  @Output() communication_matrix : EventEmitter<boolean> = new EventEmitter;
  @Input () cartonid = "";
  id:any ;
  formGroup:FormGroup;
  cursor_point: any = "";
  cartonLocalDetail : any = {};
  comm_matrix: any = {
    oActive_sms: '',
    oActive_sms_field: '',
    oActive_notification: '',
    oActive_notification_field: '',
    reminder_sms: '',
    reminder_smsField: '',
    reminder_notification: '',
    reminder_notificationField: '',
    fulfill_sms: '',
    fulfill_smsField: '',
    fulfill_notification: '',
    fulfill_notificationField: '',
    oActive_sms_template: '',
    reminder_sms_template: '',
    fulfill_sms_template: '',
    oActive_id:'',
    remainder_id:'',
    fulfillment_id:''
  }
  onactiveFieldData:any ={}
  reminderFieldData:any ={}
  fulfillFieldData:any = {}
  campaignId:any = ''
  onActive : any = [];
  reminder : any = [];
  fulfilment : any = []
  constructor(
    private ngWizardService: NgWizardService,
    private router: Router,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private fb: FormBuilder,
    private toast: ToastClientService,
    private activatedRoute: ActivatedRoute,


  ) { }
  ngOnInit() {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.campaignId = this.activatedRoute.snapshot.paramMap.get('cartonid');
    this.cartonLocalDetail = JSON.parse(localStorage.getItem('cartonFlgs'))
    this.getFields()
    this.formGroup = this.fb.group({
      oActive_sms_template: new FormControl("", Validators.required),
      oActive_sms: new FormControl("", Validators.required),
      oActive_smsField: new FormControl(""),
      oActive_notification: new FormControl("", Validators.required),
      oActive_notificationField: new FormControl(""),
      reminder_sms_template: new FormControl("", Validators.required),
      reminder_sms: new FormControl("", Validators.required),
      reminder_smsField: new FormControl(""),
      reminder_notificationField: new FormControl(""),
      reminder_notification: new FormControl("", Validators.required),
      fulfill_sms_template: new FormControl("", Validators.required),
      fulfill_sms: new FormControl("", Validators.required),
      fulfill_smsField: new FormControl(""),
      fulfill_notification: new FormControl("", Validators.required),
      fulfill_notificationField: new FormControl(""),
      oActive_id: new FormControl(''),
      remainder_id: new FormControl(''),
      fulfilment_id: new FormControl(''),

    })
    this.getComm_matrix()
  }
  getFields(){
    this.apiService.get(this.apiConfig.getfields).subscribe((res:any)=>{
      console.log(res);
      this.onactiveFieldData = res.data.onActive
      this.reminderFieldData = res.data.onRemainder
      this.fulfillFieldData = res.data.rewardFulfillment

    })
  }
  cursorEvent(oField) {
    if (oField.selectionStart || oField.selectionStart == '0') {
      let caretPos = oField.selectionStart;
      this.cursor_point = caretPos;
    }
  }

  appendDynamicDataInMsg(selected_field, discription, num) {
    if (num == 1) {
      if (!selected_field) {
        this.toast.Error("Select the value")
        return
      }
      let leng = discription.length;
      if (leng == this.cursor_point) {
        this.comm_matrix.oActive_sms += selected_field;
      } else {
        if (this.cursor_point) {
          var firstText = this.comm_matrix.oActive_sms.substr(0, this.cursor_point); // Gets the first part
          var secoundText = this.comm_matrix.oActive_sms.substr(this.cursor_point); // Gets the secound part
          this.comm_matrix.oActive_sms = firstText + selected_field + secoundText;
        } else {
          this.comm_matrix.oActive_sms += selected_field;
        }
      }

    } else if(num == 11){
      if (!selected_field) {
        this.toast.Error("Select the value")
        return
      }
      let leng = discription.length;
      if (leng == this.cursor_point) {
        this.comm_matrix.oActive_notification += selected_field;
      } else {
        if (this.cursor_point) {
          var firstText = this.comm_matrix.oActive_notification.substr(0, this.cursor_point); // Gets the first part
          var secoundText = this.comm_matrix.oActive_notification.substr(this.cursor_point); // Gets the secound part
          this.comm_matrix.oActive_notification = firstText + selected_field + secoundText;
        } else {
          this.comm_matrix.oActive_notification += selected_field;
        }
      }
        }
    else if(num == 2){
      if (!selected_field) {
        this.toast.Error("Select the value")
        return
      }
      let leng = discription.length;
      if (leng == this.cursor_point) {
        this.comm_matrix.reminder_sms += selected_field;
      } else {
        if (this.cursor_point) {
          var firstText = this.comm_matrix.reminder_sms.substr(0, this.cursor_point); // Gets the first part
          var secoundText = this.comm_matrix.reminder_sms.substr(this.cursor_point); // Gets the secound part
          this.comm_matrix.reminder_sms = firstText + selected_field + secoundText;
        } else {
          this.comm_matrix.reminder_sms += selected_field;
        }
      }

    }else if(num == 22){
      if (!selected_field) {
        this.toast.Error("Select the value")
        return
      }
      let leng = discription.length;
      if (leng == this.cursor_point) {
        this.comm_matrix.reminder_notification += selected_field;
      } else {
        if (this.cursor_point) {
          var firstText = this.comm_matrix.reminder_notification.substr(0, this.cursor_point); // Gets the first part
          var secoundText = this.comm_matrix.reminder_notification.substr(this.cursor_point); // Gets the secound part
          this.comm_matrix.reminder_notification = firstText + selected_field + secoundText;
        } else {
          this.comm_matrix.reminder_notification += selected_field;
        }
      }

    }else if(num == 3){
      if (!selected_field) {
        this.toast.Error("Select the value")
        return
      }
      let leng = discription.length;
      if (leng == this.cursor_point) {
        this.comm_matrix.fulfill_sms += selected_field;
      } else {
        if (this.cursor_point) {
          var firstText = this.comm_matrix.fulfill_sms.substr(0, this.cursor_point); // Gets the first part
          var secoundText = this.comm_matrix.fulfill_sms.substr(this.cursor_point); // Gets the secound part
          this.comm_matrix.fulfill_sms = firstText + selected_field + secoundText;
        } else {
          this.comm_matrix.fulfill_sms += selected_field;
        }
      }

    }else if(num == 33){
      if (!selected_field) {
        this.toast.Error("Select the value")
        return
      }
      let leng = discription.length;
      if (leng == this.cursor_point) {
        this.comm_matrix.fulfill_notification += selected_field;
      } else {
        if (this.cursor_point) {
          var firstText = this.comm_matrix.fulfill_notification.substr(0, this.cursor_point); // Gets the first part
          var secoundText = this.comm_matrix.fulfill_notification.substr(this.cursor_point); // Gets the secound part
          this.comm_matrix.fulfill_notification = firstText + selected_field + secoundText;
        } else {
          this.comm_matrix.fulfill_notification += selected_field;
        }
      }

    }
  }
  isEdit:boolean = false;
  submit(data){
    let payload ={
      campaign_id: this.campaignId,
      comm:{
        onActive:{
          template_id: '',
          sms:'' ,
          notification:'',
          id:''
        },
        onRemainder:{
          template_id: '',
          sms:'' ,
          notification:'',
          id:''
        },
        rewardFulfilment:{
          template_id: '',
          sms:'' ,
          notification:'',
          id:''
        }
      }
    }
    console.log(payload)
    if(this.formGroup.invalid){
      console.log(this.formGroup.invalid,this.formGroup.value)
      return
    } else {
      if (!this.isEdit) {
        payload.comm.onActive.template_id = data.oActive_sms_template
        payload.comm.onActive.sms = data.oActive_sms
        payload.comm.onActive.notification = data.oActive_notification

        payload.comm.onRemainder.template_id = data.reminder_sms_template
        payload.comm.onRemainder.sms = data.reminder_sms
        payload.comm.onRemainder.notification = data.reminder_notification

        payload.comm.rewardFulfilment.template_id = data.fulfill_sms_template
        payload.comm.rewardFulfilment.sms = data.fulfill_sms
        payload.comm.rewardFulfilment.notification = data.fulfill_notification

        this.apiService.post(this.apiConfig.comm_matrix, payload).subscribe((res: any) => {
          console.log(res)
          this.communication_matrix.emit(true)
          this.toast.Success("Successfull")
          setTimeout(() => {
            this.router.navigate(["/hubAdmin/carton-list"])
          }, 500);
        })
      }
      else {
        payload.comm.onActive.template_id = data.oActive_sms_template
        payload.comm.onActive.sms = data.oActive_sms
        payload.comm.onActive.notification = data.oActive_notification
        payload.comm.onActive.id = data.oActive_id

        payload.comm.onRemainder.template_id = data.reminder_sms_template
        payload.comm.onRemainder.sms = data.reminder_sms
        payload.comm.onRemainder.notification = data.reminder_notification
        payload.comm.onRemainder.id = data.remainder_id


        payload.comm.rewardFulfilment.template_id = data.fulfill_sms_template
        payload.comm.rewardFulfilment.sms = data.fulfill_sms
        payload.comm.rewardFulfilment.notification = data.fulfill_notification
        payload.comm.rewardFulfilment.id = data.fulfilment_id

      }
      console.log(this.formGroup.invalid, this.formGroup.value)
      this.apiService.post(this.apiConfig.updateComm_matrix, payload).subscribe((res: any) => {
        console.log(res)
        this.communication_matrix.emit(true)
        this.toast.Success("Successfull")
        setTimeout(() => {
          this.router.navigate(["/hubAdmin/carton-list"])
        }, 500);
      })
    }
  }
  getComm_matrix(){
    console.log("flags.......",localStorage.getItem("cartonFlgs"))
    this.apiService.get(this.apiConfig.getrewardBifurcation+`?campaign_id=${this.campaignId}&parameter=2`).subscribe((res:any)=>{
      console.log(res)
      this.onActive = res.data.filter((e) => e.message_action == 'onActive')
      this.fulfilment = res.data.filter((e) => e.message_action == 'rewardFulfilment')
      this.reminder = res.data.filter((e) => e.message_action == 'onRemainder')
      this.isEdit = (this.onActive != 0 || this.fulfilment !=0 || this.reminder !=0)
      if (this.onActive != 0 && this.fulfilment !=0 && this.reminder !=0) {
        console.log(this.onActive, this.fulfilment, this.reminder)
        this.comm_matrix.oActive_sms_template = this.onActive[0].template_id
        this.comm_matrix.oActive_sms = this.onActive[0].message_content
        this.comm_matrix.oActive_notification = this.onActive[0].notification_content
        this.comm_matrix.oActive_id = this.onActive[0].id
        this.formGroup.controls.oActive_id.setValue(this.onActive[0].id)

        this.comm_matrix.reminder_sms = this.reminder[0].message_content
        this.comm_matrix.reminder_sms_template = this.reminder[0].template_id
        this.comm_matrix.reminder_notification = this.reminder[0].notification_content
        this.comm_matrix.remainder_id = this.reminder[0].id
        this.formGroup.controls.remainder_id.setValue(this.reminder[0].id)

        this.comm_matrix.fulfill_sms_template = this.fulfilment[0].template_id
        this.comm_matrix.fulfill_sms = this.fulfilment[0].message_content
        this.comm_matrix.fulfill_notification = this.fulfilment[0].notification_content
        this.comm_matrix.fulfilment_id = this.fulfilment[0].id
        this.formGroup.controls.fulfilment_id.setValue(this.fulfilment[0].id)
      }

    })
  }
}
